import { FormControl, FormHelperText } from '@mui/material';
import { ReactNode } from 'react';

import { RewardTransactionAction } from '@jebel/constants';

import { FormTextField } from 'shared/components/ui';

import { Container, Title } from './SettingsCommunityPointsPerAction.styles';

interface Props {
  title: string;
  description: ReactNode;
  field: RewardTransactionAction;
  disabled?: boolean;
}

export function SettingsCommunityPointsPerAction(props: Props) {
  return (
    <Container>
      <Title htmlFor={props.field}>{props.title}</Title>

      <FormControl>
        <FormTextField
          type="number"
          id={props.field}
          name={props.field}
          disabled={props.disabled}
          InputProps={{
            inputProps: { min: 0 },
            defaultValue: 0,
          }}
        />

        <FormHelperText>{props.description}</FormHelperText>
      </FormControl>
    </Container>
  );
}
